import { updateUserInfoAgreeFlagOn, getUserInfo } from "../../api/api";
import { useNavigate, Link } from 'react-router-dom';
import { useAtom, atom } from 'jotai';
import { userInfoAtom } from '../../atom';

const checkBoxAtom = atom(false)

function MainComponent({ handleLoading }) {

    document.title = "個人情報取得の同意| ファーストコンタクトセンター";
    const imageUrlPopUp = require("../../images/popup.png")
    const [checkBox, setCheckBox] = useAtom(checkBoxAtom);
    const [, setUserInfo] = useAtom(userInfoAtom);
    const navigate = useNavigate();

    const handleCheckBoxChange = (event) => {
        setCheckBox(event.target.checked);
    }

    const goNext = async () => {
        const nameCheck = ["", undefined, null, false];
        if (checkBox !== true) {
            alert("個人情報の同意をチェックしてください。");
            return;
        }
        handleLoading(true);
        const data = await updateUserInfoAgreeFlagOn();
        if (!data) {
            alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
        }
        const userInfo = await getUserInfo();
        let checkIsPb = localStorage.getItem("isPB") === "true";
        if (!userInfo) {
            navigate("/fcc_login");
            handleLoading(false);
            return;
        }
        localStorage.setItem("agreement", userInfo.agreeFlg)
        if (checkIsPb === true) {
            if (nameCheck.includes(userInfo.sei)
                || nameCheck.includes(userInfo.mei)
                || nameCheck.includes(userInfo.seiYomi)
                || nameCheck.includes(userInfo.meiYomi)
                || nameCheck.includes(userInfo.departmentName)
                || nameCheck.includes(userInfo.telNo)
            ) {
                // 漢字名入力画面に遷移する
                navigate("/input_kanji_name", { state: { page: true } });
                return;
            }
        }
        const userInforStorage = {
            sei: userInfo.sei,
            mei: userInfo.mei,
            seiYomi: userInfo.seiYomi,
            meiYomi: userInfo.meiYomi,
            departmentName: userInfo.departmentName,
            telNo: userInfo.telNo
        }
        localStorage.setItem("userInfoStorage", JSON.stringify(userInforStorage));
        const userName = `${userInfo.sei} ${userInfo.mei}`;
        const userId = localStorage.getItem('userId');
        const user = {
            userId: userId,
            userName: userName,
        };
        setUserInfo(user);
        handleLoading(false);

        navigate("/inquiry_status", { state: { pageSubmit: false } });

    }


    return (
        <>
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="str-outer-wide">
                        <div className="str-inner">
                            <div className="mod-hdg-l1">
                                <div className="inner">
                                    <h1 className="hdg">Web問い合わせシステム</h1>
                                    <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                                </div>
                            </div>
                            <h2 className="mod-hdg-l2-02">
                                <span> 個人情報取得の同意</span>
                            </h2>

                            <div className="mod-txt">
                                <p><em>サービス開始前に個人情報の同意をお願いします。</em></p>
                                <p><em>NEC ファーストコンタクトセンターにおける個人情報の取扱いについては、<img src={imageUrlPopUp} alt="new window" /> <Link to="/handle_personal_info" target="_blank" rel="noreferrer" >「個人情報の取扱い」</Link>に記載しております。</em></p>
                            </div>
                            <br></br>
                            <div className="mod-input-check">
                                <ul className="list">
                                    <li><label>
                                        <input type="checkbox" id="mynumber" name="mynumber" onChange={handleCheckBoxChange} />
                                        <span className="label">同意する</span>
                                    </label></li>
                                </ul>
                            </div>
                            <input type="hidden" id="mynumber_date" name="mynumber_date" value="" />
                            <div className="mod-btn of-list">
                                <div className="btn">
                                    <button id="btn-confirm" className="btn_default_select" onClick={goNext}>送信する</button>
                                </div>
                            </div>



                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}

export default MainComponent;